import React from "react";
import { Navigate } from "react-router-dom";

// Layouts
import AuthLayout from "./layouts/Auth.js";
import DashboardLayout from "./layouts/Dashboard.js";

// Guards
import AuthGuard from "./components/guards/AuthGuard.js";
import AdminGuard from "./components/guards/AdminGuard.js";
import GuestGuard from "./components/guards/GuestGuard.js";

// Auth
import SignIn from "./pages/auth/SignIn.js";

// Protected routes
import Events from "./pages/protected/Events.js";
import Applications from "./pages/protected/Applications.js";
import Users from "./pages/protected/Users.js";
import Logs from "./pages/protected/Logs.js";
import Trello from "./pages/protected/Trello.js";
import OtherProject from "./pages/protected/OtherProject.js";
import StorageManager from "./pages/protected/StorageManager.js";
import Servers from "./pages/protected/Servers.js";
import SystemSettings from "./pages/protected/SystemSettings.js";


const routes = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Events />,
      },
      {
        path: "eventos",
        element: <Events />,
      },
      {
        path: "aplicativos",
        element: <Applications />,
      },
      {
        path: "usuarios",
        element: (
          <AdminGuard>
            <Users />
          </AdminGuard>
        ),
      },
      {
        path: "logs",
        element: (
          <AdminGuard>
            <Logs />
          </AdminGuard>
        ),
      },
      {
        path: "armazenamento",
        element: (
          <AdminGuard>
            <StorageManager />
          </AdminGuard>
        ),
      },
      {
        path: "servidores",
        element: (
          <AdminGuard>
            <Servers />
          </AdminGuard>
        ),
      },
      {
        path: "upload",
        element: <Navigate to="/armazenamento" replace />,
      },
      {
        path: "trello",
        element: (
          <AdminGuard>
            <Trello />
          </AdminGuard>
        ),
      },
      {
        path: "configuracoes-do-sistema",
        element: (
          <AdminGuard>
            <SystemSettings />
          </AdminGuard>
        ),
      },
      {
        path: "configuracoes",
        element: <Navigate to="/configuracoes-do-sistema" replace />,
      },
      {
        path: "outros-projetos/ai-vision",
        element: (
          <AdminGuard>
            <OtherProject projectKey="aiVision" />
          </AdminGuard>
        ),
      },
      {
        path: "outros-projetos/experiencias",
        element: (
          <AdminGuard>
            <OtherProject projectKey="experiencias" />
          </AdminGuard>
        ),
      },
      {
        path: "outros-projetos/rfid-controller",
        element: (
          <AdminGuard>
            <OtherProject projectKey="rfidController" />
          </AdminGuard>
        ),
      },
      {
        path: "ajuda/*",
        element: (
          <AdminGuard>
            <React.Fragment />
          </AdminGuard>
        ),
      },
      {
        path: "*",
        element: <Events />,
      }
    ],
  },
  {
    path: "/login",
    element:
      <GuestGuard>
        <AuthLayout />
      </GuestGuard>,
    children: [
      {
        path: "",
        element: <SignIn />,
      }
    ],
  }
];

export default routes;
